/* eslint-disable import/first */
import Vue from 'vue';
import VueLogger from 'vuejs-logger';
import { getSafe } from '@/application/services/get-safe';
import App from './ui/App.vue';
import router from './ui/router';
import store from './ui/store';
import i18n from './ui/i18n';

// Plugins
import './ui/plugins/VeeValidate';
import './ui/plugins/Buefy';
import './ui/plugins/FontAwesome';
import './ui/plugins/vue-google';
import './ui/plugins/VueClipboard';
// import './ui/plugins/Socket.io';
// Estilos
import '@/ui/assets/fonts/creditu-icons.css';
import '@/ui/assets/css/main.scss';
import '@/ui/assets/css/layout.css';

const isProduction = process.env.NODE_ENV === 'prod';
const options = {
  isEnabled: true,
  logLevel: isProduction ? 'error' : 'debug',
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: '|',
  showConsoleColors: true
};
Vue.use(VueLogger, options);

Vue.config.productionTip = false;

Vue.prototype.$getSafe = getSafe;
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
